import React, { useEffect, useState, useCallback } from 'react';
import { formatCurrency } from '../../tools/tool';
import { adminServices } from '../../services/AdminServices';
import IcarusServices from '../../services/IcarusServices';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const TransactionFeesCard = ({
  dateRange
}) => {
  const navigate = useNavigate();
  const [kioskFees, setKioskFees] = useState(0);
  const [posFees, setPosFees] = useState(0);
  const [, setSalesPayment] = useState(0);
  const [walkinFees, setWalkinFees] = useState(0);
  const [onlineFees, setOnlineFees] = useState(0);
  const [grossProfit, setGrossProfit] = useState(0);
  const getTransactionFees = useCallback(async () => {
    try {
      let kioskSP = 'service_fees';
      let params = {};
      let walkinMerchantFee = 0;
      if (dateRange.dateFrom && dateRange.dateTo) {
        params = {
          dateFrom: dateRange.dateFrom,
          dateTo: dateRange.dateTo
        };
        kioskSP = 'service_fees_range';
      } else {
        params = {};
      }
      try {
        const kioskResponse = await adminServices.storeProcedure2(kioskSP, params);
        if (kioskResponse.status === 200) {
          if (dateRange.dateFrom && dateRange.dateTo && Array.isArray(kioskResponse.data)) {
            const kioskTotal = kioskResponse.data.reduce((total, item) => {
              return total + Math.abs(item.service_fee || 0);
            }, 0);
            setKioskFees(kioskTotal);
          } else {
            const singleValue = kioskResponse.data[0]?.service_fees || 0;
            setKioskFees(singleValue);
          }
        } else {
          setKioskFees(0);
        }
      } catch (error) {
        setKioskFees(0);
      }
      let posSP = 'pos_fees';
      params = {};
      if (dateRange.dateFrom && dateRange.dateTo) {
        params = {
          dateFrom: dateRange.dateFrom,
          dateTo: dateRange.dateTo
        };
        posSP = 'pos_fees_range';
      } else {
        params = {};
      }
      try {
        const posResponse = await adminServices.storeProcedure2(posSP, params);
        if (posResponse.status === 200) {
          if (dateRange.dateFrom && dateRange.dateTo && Array.isArray(posResponse.data)) {
            const posTotal = posResponse.data.reduce((total, item) => total + Math.abs(item.pos_fee || 0), 0);
            setPosFees(posTotal);
          } else {
            setPosFees(posResponse.data[0]?.pos_fee || 0);
          }
        } else {
          setPosFees(0);
        }
      } catch (error) {
        setPosFees(0);
      }
      let walkinSP = 'padala_report';
      params = {};
      if (dateRange.dateFrom && dateRange.dateTo) {
        params = {
          dateFrom: dateRange.dateFrom,
          dateTo: dateRange.dateTo
        };
        walkinSP = 'padala_report_range';
      } else {
        params = {};
      }
      try {
        const walkinResponse = await adminServices.storeProcedure2(walkinSP, params);
        if (walkinResponse.status === 200 && walkinResponse.data && walkinResponse.data.length > 0) {
          const srcRows = walkinResponse.data.map(r => ({
            src: (r.cash_in_from || '').toString().toLowerCase(),
            interest: Math.abs(r.interest_rate || 0)
          }));
          const walkinTotal = srcRows.filter(r => r.src.includes('walk')).reduce((t, r) => t + r.interest, 0);
          const onlineTotal = srcRows.filter(r => r.src.includes('padala') || r.src.includes('ecpay')).reduce((t, r) => t + r.interest, 0);
          setOnlineFees(onlineTotal);
          params = {};
          if (dateRange.dateFrom && dateRange.dateTo) {
            params = {
              dateFrom: dateRange.dateFrom,
              dateTo: dateRange.dateTo
            };
          } else {
            params = {};
          }
          const merchantPadala = await adminServices.storeProcedure2('merchant_' + walkinSP, params);
          if (merchantPadala.status === 200 && merchantPadala.data && merchantPadala.data.length > 0) {
            walkinMerchantFee = merchantPadala.data.reduce((total, item) => total + Math.abs(item.interest_rate || 0), 0);
          }
          setWalkinFees(walkinTotal + walkinMerchantFee);

          //console.log('Walkin Fees:', walkinTotal + walkinMerchantFee, 'Online Fees:', onlineTotal);
        } else {
          setWalkinFees(0);
          setOnlineFees(0);
        }
      } catch (error) {
        setWalkinFees(0);
      }
      setGrossProfit(0);

      // const otherFormData = new FormData();
      // params = {};
      // try {
      //   const otherResponse = await adminServices.storeProcedure2('transaction_fees', params);
      //   if (otherResponse.status === 200) {
      //     setSalesPayment(otherResponse.data[0]?.sales_payment || 0);
      //   } else {
      //     setSalesPayment(0);
      //   }
      // } catch (error) {
      //   setSalesPayment(0);
      // }
    } catch (error) {
      if (error.status === 401) {
        navigate('/');
      }
      if (error.status === 429) {
        toast.error('Too many requests. Data will retry in 1 minute.');
        setTimeout(async () => {
          await getTransactionFees();
        }, 60000);
      }
    }
  }, [navigate, dateRange]);
  useEffect(() => {
    getTransactionFees();
  }, [getTransactionFees, dateRange]);
  return <div className="card" style={{
    width: '100%',
    marginBottom: '20px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  }}>
      <div className="card-body" style={{
      padding: '20px'
    }}>
        <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px'
      }}>
          {/* Process Fee Card */}
          <div style={{
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          padding: '15px',
          position: 'relative'
        }}>
            <h6 style={{
            color: '#333',
            fontWeight: 'bold',
            marginBottom: '15px',
            textAlign: 'center'
          }}>PROCESSING FEE</h6>
            <div style={{
            borderBottom: '1px solid #e0e0e0',
            borderTop: '1px solid #e0e0e0',
            paddingBottom: '40px',
            paddingTop: '40px',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
              <p style={{
              margin: 0,
              fontSize: '32px',
              fontWeight: 'bold',
              color: '#333'
            }}>
              {formatCurrency((kioskFees || 0) + (posFees || 0))}
              </p>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px'
          }}>
              <div style={{
              textAlign: 'center'
            }}>
                <p style={{
                margin: '0 0 5px 0',
                fontSize: '14px',
                color: '#666'
              }}>Kiosk Charge</p>
                <p style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                  {formatCurrency(kioskFees || 0)}
                </p>
                <button onClick={() => navigate('/ipx-transactions?type=kiosk')} style={{
                background: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '5px 10px',
                fontSize: '12px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }} onMouseOver={e => e.target.style.background = '#0056b3'} onMouseOut={e => e.target.style.background = '#007bff'}>
                  Show Details
                </button>
              </div>
              <div style={{
              textAlign: 'center'
            }}>
                <p style={{
                margin: '0 0 5px 0',
                fontSize: '14px',
                color: '#666'
              }}>POS Charge</p>
                <p style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                  {formatCurrency(posFees || 0)}
                </p>
                <button onClick={() => navigate('/ipx-transactions?type=pos')} style={{
                background: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '5px 10px',
                fontSize: '12px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }} onMouseOver={e => e.target.style.background = '#0056b3'} onMouseOut={e => e.target.style.background = '#007bff'}>
                  Show Details
                </button>
              </div>
            </div>
          </div>
                
          {/* Loading Fee Card */}
          <div style={{
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          padding: '15px',
          position: 'relative'
        }}>
            <h6 style={{
            color: '#333',
            fontWeight: 'bold',
            marginBottom: '15px',
            textAlign: 'center'
          }}>LOADING FEE</h6>
            <div style={{
            borderBottom: '1px solid #e0e0e0',
            borderTop: '1px solid #e0e0e0',
            paddingBottom: '40px',
            paddingTop: '40px',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
              <p style={{
              margin: 0,
              fontSize: '32px',
              fontWeight: 'bold',
              color: '#333'
            }}>
                {formatCurrency((walkinFees || 0) + (onlineFees || 0))}
              </p>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px'
          }}>
              <div style={{
              textAlign: 'center'
            }}>
                <p style={{
                margin: '0 0 5px 0',
                fontSize: '14px',
                color: '#666'
              }}>Walkin Fees</p>
                <p style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                  {formatCurrency(walkinFees || 0)}
                </p>
              </div>
              <div style={{
              textAlign: 'center'
            }}>
                <p style={{
                margin: '0 0 5px 0',
                fontSize: '14px',
                color: '#666'
              }}>Online Fees Icarus & Ecpay</p>
                <p style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                  {formatCurrency(onlineFees || 0)}
                </p>
              </div>
            </div>
          </div>

          {/* Gross Profit Card */}
          <div style={{
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          padding: '15px',
          position: 'relative'
        }}>
            <h6 style={{
            color: '#333',
            fontWeight: 'bold',
            marginBottom: '15px',
            textAlign: 'center'
          }}>PURCHASE ORDER</h6>
            <div style={{
            borderBottom: '1px solid #e0e0e0',
            borderTop: '1px solid #e0e0e0',
            paddingBottom: '40px',
            paddingTop: '40px',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
              <p style={{
              margin: 0,
              fontSize: '32px',
              fontWeight: 'bold',
              color: '#333'
            }}>
                {formatCurrency(grossProfit || 0)}
              </p>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px'
          }}>
              <div style={{
              textAlign: 'center'
            }}>
                <p style={{
                margin: '0 0 5px 0',
                fontSize: '14px',
                color: '#666'
              }}>Regular Orders</p>
                <p style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                  {formatCurrency((grossProfit || 0) * 0.7)}
                </p>
              </div>
              <div style={{
              textAlign: 'center'
            }}>
                <p style={{
                margin: '0 0 5px 0',
                fontSize: '14px',
                color: '#666'
              }}>Special Orders</p>
                <p style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                  {formatCurrency((grossProfit || 0) * 0.3)}
                </p>
              </div>
            </div>
          </div>

          {/* Sales Payment Card */}
          <div style={{
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          padding: '15px',
          position: 'relative'
        }}>
            <h6 style={{
            color: '#333',
            fontWeight: 'bold',
            marginBottom: '15px',
            textAlign: 'center'
          }}>SALES ORDER</h6>
            <div style={{
            borderBottom: '1px solid #e0e0e0',
            borderTop: '1px solid #e0e0e0',
            paddingBottom: '40px',
            paddingTop: '40px',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
              <p style={{
              margin: 0,
              fontSize: '32px',
              fontWeight: 'bold',
              color: '#333'
            }}>
                {formatCurrency(0)}
              </p>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px'
          }}>
              <div style={{
              textAlign: 'center'
            }}>
                <p style={{
                margin: '0 0 5px 0',
                fontSize: '14px',
                color: '#666'
              }}>Regular Order</p>
                <p style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                  {formatCurrency(0)}
                </p>
              </div>
              <div style={{
              textAlign: 'center'
            }}>
                <p style={{
                margin: '0 0 5px 0',
                fontSize: '14px',
                color: '#666'
              }}>Special Order</p>
                <p style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                  {formatCurrency(0)}
                </p>
              </div>
            </div>
          </div>

          

          
        </div>
      </div>
    </div>;
};
export default TransactionFeesCard;